import { render, staticRenderFns } from "./AssetPreviewVideoTranscriptControls.vue?vue&type=template&id=5a86432e&scoped=true&"
import script from "./AssetPreviewVideoTranscriptControls.vue?vue&type=script&lang=js&"
export * from "./AssetPreviewVideoTranscriptControls.vue?vue&type=script&lang=js&"
import style0 from "./AssetPreviewVideoTranscriptControls.vue?vue&type=style&index=0&id=5a86432e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a86432e",
  null
  
)

export default component.exports